const FullScreenLoader = ({
  height,
}: {
  height: number;
}) => {
  return (
    <section
      className='flex items-center justify-center'
      style={{ height: height ? height : '100vh' }}
    >
      <span className='loading loading-ring loading-md'></span>
    </section>
  );
};

export default FullScreenLoader;
